import React, { FC, MutableRefObject, useEffect, useRef, useState } from 'react'
import { EditorJsComponent } from 'Pages/admin'
import { landingApi } from 'Pages/landings/common/api'
import { OutLinks } from 'Pages/landings/common/constants'
import { Agreement, Politics, Title, Modal, ModalTitle } from './styled'

interface DynamicAgreementProps {
	token: string
	orderID: MutableRefObject<number | null>
}

export const DynamicAgreement: FC<DynamicAgreementProps> = ({ token, orderID }): JSX.Element => {
	const replaceFields = useRef(null)
	const agreementModel = useRef(null)
	const [isAgreementReady, setIsAgreementReady] = useState(false)
	useEffect(() => {
		const escapingQuotes = (field: string): string => (field ?? '').replace(/"/g, '\\"')
		const agreementInfo = async () => {
			try {
				agreementModel.current = await landingApi.getAgreementModel()
			} catch (err) {
				/* eslint-disable-next-line */
				console.log(err)
			} finally {
				const info = await landingApi.getPartnerInfo(token)
				orderID.current = info.id
				replaceFields.current = {
					name_full: escapingQuotes(info.partner?.name_full),
					bin_number: escapingQuotes(info.partner?.bin_number),
					actual_address: escapingQuotes(info.partner?.actual_address),
					postal_code: escapingQuotes(info.partner?.postal_code),
					postal_address: escapingQuotes(info.partner?.postal_address),
					department_name: escapingQuotes(
						info?.department_for_agreement?.name
							? `Подчиненное подразделение ${info?.department_for_agreement?.name},`
							: ''
					),
					department_ogrn: escapingQuotes(
						info?.department_for_agreement?.ogrn
							? `ОГРН ${info?.department_for_agreement?.ogrn},`
							: ''
					),
					department_address: escapingQuotes(
						info?.department_for_agreement?.address
							? `Российская Федерация, ${info?.department_for_agreement?.address}`
							: ''
					),
				}
			}
		}
		if (token) agreementInfo()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [token])

	const makeAgreement = () => {
		document.body.style.overflowY = 'hidden'
		setIsAgreementReady(true)
	}
	return (
		<>
			<Title page={window.location.href}>
				Нажимая на кнопку «Отправить заявку», вы соглашаетесь с&nbsp;
				<Agreement onClick={makeAgreement} page={window.location.href}>
					условиями на передачу персональных данных
				</Agreement>
				&nbsp;и принимаете&nbsp;
				<Politics href={OutLinks.privacyPolicyHref} target="_blank" page={window.location.href}>
					политику конфиденциальности
				</Politics>
			</Title>
			{isAgreementReady && (
				<Modal width="50%" isScroll closeModal={() => setIsAgreementReady(false)}>
					<ModalTitle>{agreementModel?.current?.title}</ModalTitle>
					<EditorJsComponent
						initialData={agreementModel?.current?.body ?? ''}
						replaceFields={replaceFields?.current}
					/>
				</Modal>
			)}
		</>
	)
}
